<template>
  <div class="dialog-scroll">
    <el-dialog
      class="search-popup"
      :title="$t('title.popup.system.tenant.search')"
      :visible.sync="dialogVisible"
      @close="resetForms"
      :before-close="handleDialogClose">
      <!-- 検索エリア 開始 -->

    <el-form
      @submit.native.prevent
      :model="query"
      :rules="rules"
      ref="ruleForm">
        <el-row :gutter="16">
          <el-col class="col">
            <el-form-item prop="tenantExId" class="input_item">
              <el-input
                class="input-class"
                maxlength="20"
                :placeholder="$t('label.common.tenantIdPlaceHolder')"
                v-model="query.tenantExId">
              </el-input>
            </el-form-item>
            <el-form-item prop="tenantName" class="input_item">
              <el-input
                maxlength="50"
                class="input-class"
                :placeholder="$t('label.common.tenantNamePlaceHolder')"
                size="small"
                v-model="query.tenantName">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div class="form-group">
              <narrow-down @click="searchTenant">
                {{ $t("button.common.narrow") }}
              </narrow-down>
              <cancel-narrow-down @click="clearSearchParams" class="margin-left-8 link-primary">
                {{ $t("button.common.cancelNarrow") }}
              </cancel-narrow-down>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <!-- 検索エリア 終了 -->

      <!-- 検索結果 開始 -->
      <div v-show="isshow" class="search-common">
        <label class="font-size-16 lable-right-16">{{ $t("label.common.count") }}</label>
        <el-select @change="changePageSize" class="page-select" v-model="query.pageSize">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>

      <div id="popup-area-search-result" v-show="isshow" class="table-type master-table-type">
        <el-table :data="searchResult.content">
          <el-table-column
            prop="tenantExId"
            class-name="col-3"
            :label="$t('label.popup.system.tenant.label.tenantExId')"
          />
          <el-table-column
            prop="tenantName"
            class-name="col-6"
            :label="$t('label.popup.system.tenant.label.tenantName')"
          />
          <el-table-column
            prop="address"
            class-name="col-6"
            :label="$t('label.popup.system.tenant.label.address')"
          />
          <el-table-column
            prop="telNo"
            class-name="col-3"
            :label="$t('label.popup.system.tenant.label.telNo')"
          />
          <el-table-column class-name="col-2">
            <div slot-scope="scope" class="detail-button with-100">
              <sp-smart-button @click="selectTenant(scope.row)" class="detail-button with-100">
                {{ $t("button.common.select") }}
              </sp-smart-button>
            </div>
          </el-table-column>
        </el-table>
      </div>
      <!-- 検索結果 終了 -->
      <!-- 分页 開始 -->
      <pagination
        class="m-top-5"
        v-show="searchResult.content.length > 0"
        :page-size="query.pageSize"
        :page-number="searchResult.pageNumber"
        :totalPage="searchResult.totalPage"
        :totalCount="searchResult.totalCount"
        @on-paging="handlePageChange"
      >
      </pagination>
      <!-- 分页 終了 -->
    </el-dialog>
  </div>
</template>

<script>
import PopupRulesFactory from "@/rules/rule-popup-tenant";
import Pagination from "@/components/common/pagination/Pagination";
import SystemManageApi from "@/api/SystemManageApi";
import errorCodeMsg from "@/utils/error-code-msg"
import narrowDown from "@/components/common/generalButton/NarrowDown";
import cancelNarrowDown from "@/components/common/generalButton/CancelNarrowDown";
import SpSmartButton from "@/components/common/sp-smart-button"
const DEFAULT_PAGE_SIZE = 10;
const DEFAULT_PAGE_NUMBER = 1;
const EVENT_ON_SELECTED = "on-selected";
export default {
components: {
    Pagination: Pagination,
    narrowDown,
    cancelNarrowDown,
    SpSmartButton,
  },
  name: "TenantSearchPopup",
  props: {
    tenantEXId: String,
    tenantName: String,
    visible: Boolean,
    ownerId: String,
    buildingId: String,
    includeDeleteDataFlag: {
      type: Boolean,
      default: true
    },
    includeDummyDataFlag: {
      type: Boolean,
      default: true
    },
  },
  data: function () {
    return {
      isshow: false,
      rules: PopupRulesFactory.popupRules(this),
      query: {
        ownerExId: null,
        ownerId: null,
        ownerName: null,
        buildingExId: null,
        buildingId: null,
        buildingName: null,
        tenantName: null,
        tenantId: null,
        tenantExId: null,
        pageSize: DEFAULT_PAGE_SIZE,
        pageNumber: DEFAULT_PAGE_NUMBER,
      },
      searchResult: {
        pageSize: DEFAULT_PAGE_SIZE,
        pageNumber: DEFAULT_PAGE_NUMBER,
        totalPage: 0,
        totalCount: 0,
        content: [],
      },
      dialogVisible: this.visible,
      isSearching: false,
      options: [
        {
          value: 10,
          label: "",
        },
        {
          value: 20,
          label: "",
        },
        {
          value: 50,
          label: "",
        },
      ],
    };
  },
  watch: {
    visible: function (value) {
      this.dialogVisible = value;
      this.query.tenantExId = this.tenantEXId
      this.query.tenantName = this.tenantName
    },
  },
  methods: {
    resetForms() {
      this.$refs['ruleForm'].resetFields()
    },
    changePageSize(){
      this.query.pageNumber = 1
      this.searchTenant()
    },

    searchTenant: function () {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          if (!this.isSearching) {
            this.isSearching = true;
            this.showTableLoadingAnim();
            if(this.includeDeleteDataFlag == null) {
              this.includeDeleteDataFlag = true
            }
            if(this.includeDummyDataFlag == null) {
              this.includeDummyDataFlag = true
            }
            SystemManageApi.searchTenant({
              ownerExId: this.query.ownerExId,
              ownerName: this.query.ownerName,
              ownerId: this.query.ownerId,
              buildingExId: this.query.buildingExId,
              buildingName: this.query.buildingName,
              buildingId: this.query.buildingId,
              tenantName: this.query.tenantName,
              tenantId: this.query.tenantId,
              tenantExId: this.query.tenantExId,
              includeDeleteDataFlag: this.includeDeleteDataFlag,
              includeDummyDataFlag: this.includeDummyDataFlag,
              pageSize: this.query.pageSize,
              pageNumber: this.query.pageNumber,
            })
            .catch((error) => {
              errorCodeMsg(error, this)
            })
            .then(({ data }) => {
              this.searchResult.pageSize = data.body.pageSize;
              this.searchResult.pageNumber = data.body.pageNumber;
              this.searchResult.totalPage = data.body.totalPage;
              this.searchResult.totalCount = data.body.totalCount;
              this.searchResult.content = data.body.body;
            });
          }
          this.isSearching = false;
          this.hideTableLoadingAnim();
          this.isshow = true;
        } else {
          return false;
        }
      });
    },

    selectTenant(tenant) {
      this.dialogVisible = false;
      this.$emit(EVENT_ON_SELECTED, tenant);
      this.$emit("update:visible", false);
      this.clearSearchParams();
      this.isshow = false;
    },

    /**
     * 検索条件クリア
     */
    clearSearchParams: function () {
      this.query.ownerExId = null;
      this.query.ownerName = null;
      this.query.ownerId = null;
      this.query.buildingExId = null;
      this.query.buildingName = null;
      this.query.buildingId = null;
      this.query.tenantName = null;
      this.query.tenantId = null;
      this.query.tenantExId = null;
      this.query.pageSize = DEFAULT_PAGE_SIZE;
      this.query.pageNumber = DEFAULT_PAGE_NUMBER;
      this.searchResult.content = [];
      this.$refs["ruleForm"].resetFields();
      this.isshow = false;
    },
    showTableLoadingAnim() {
      if (this.tableLoadingAnim == null) {
        this.tableLoadingAnim = this.$loading({
          target: "#popup-area-search-result",
          background: "#ebebe6"
        });
      }
    },
    hideTableLoadingAnim() {
      if (this.tableLoadingAnim != null) {
        this.tableLoadingAnim.close();
        this.tableLoadingAnim = null;
      }
    },
    handleDialogClose: function () {
      this.dialogVisible = false;
      this.$emit("update:visible", false);
      this.clearSearchParams();
    },

    handlePageChange: function (paging) {
      this.query.pageSize = paging.pageSize;
      this.query.pageNumber = paging.pageNumber;
      this.searchTenant();
    },
  },
  mounted() {
    this.query.tenantExId = this.tenantEXId;
    this.query.ownerId = this.ownerId;
    this.query.buildingId = this.buildingId;
    this.options[0].label = "10" + this.$t("label.common.case");
    this.options[1].label = "20" + this.$t("label.common.case");
    this.options[2].label = "50" + this.$t("label.common.case");
  },
};
</script>

<style lang="scss" scoped>
.title {
  height: 60px;
  font-size: 24px;
  font-weight: bold;
  // color: #2699fb;
}
.el-select {
  line-height: 42px;
  width: 100px;
  font-size: 12px;
  height: 18px;
  border-radius: 8px;
  // overflow: hidden;
  color: #fff;

  ::v-deep.el-input__inner {
    border: none;
    // line-height: 24px;
    background-color: #f2f2ed;
    color: #525250;
    // font-size: 15px !important;
    // padding-left: 20px;
    box-shadow: -2px -2px 5px #fff,
      5px 5px 8px #e6e6e1;
  }
  ::placeholder {
    color: #525250;
  }
}

.search-popup {
  ::v-deep  .el-dialog {
    width: 1024px;
    height: 700px;
    background-color: #f2f2ed;
    border-radius: 3px !important;
    ::v-deep .el-dialog__header {
      height: 50px;
      ::v-deep .el-dialog__body {
        padding: 0px 24px 0px 19px;
      }
    }
  }
}

.left-input {
  margin-top: 13px;
  width: 200px;
}
.right-input {
  margin-top: 13px;
  margin-left: 16px;
  width: 200px;
  height: 22px;
}
.col {
  display: flex;
  flex-direction: row;
}
::v-deep .el-form-item__content {
  line-height: 22px;
}
.label {
  // color: #2699fb;
  font-size: 12px;
}

.btn-operate {
  margin: 0 5px 0 0;
}
::v-deep .detail-button{
  button {
    width: 100%;
  }
  .my-button{
    width: 134px;
  }
}

::v-deep .detail-button .my-button {
  margin-left: 5px;
}
::v-deep .detail-button .my-button {
  width: 100%;
  height: 40px;
  line-height: 0;
}

// add by mxq
.input_item {
  margin-right: 20px;
  ::v-deep.el-input .el-input__inner {
    width: 296px;
    height: 44px !important;
    border-radius: 8px !important;
    background: #f2f2ed;
    border: none;
    box-shadow: -2px -2px 5px #ffffff inset, -2px -2px 5px #ffffff inset,
      4px 5px 5px #e6e6e1 inset, 4px 5px 5px #e6e6e1 inset;
  }
}

::v-deep.el-icon-close {
  color: rgb(0, 0, 0);
}
.button_title {
  font-size: 12px;
  position: relative;
  bottom: 6px;
}
.search-common {
  display: block;
  float: right;
  margin-top: 36px;
  margin-bottom: 20px;
}

::v-deep .el-dialog .el-dialog__header {
  height: 60px !important;
}
</style>
